<template>
  <div class="thai-hilo-history">
    <Tabs class="thai-hilo-history-tabs" type="card" :animated="false">
      <TabPane label="RESULT">
        <thai-hilo-result-history
          :stat="stat"
          :historical-data="rsData"
          :game="game"
          :game-code="gameCode"
          :game-id="gameId"
        />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { Tabs, TabPane, Row, Col, Badge, Message } from "iview";
import ThaiHiloResultHistory from "./thai-hilo-history/ThaiHiloResultHistory";

export default {
  props: [
    "stat",
    "historicalData",
    "game",
    "gameCode",
    "gameId",
    "gameData",
    "goodroadOn",
  ],
  components: {
    Tabs,
    TabPane,
    Badge,
    Message,
    ThaiHiloResultHistory,
  },
  data() {
    return {
      rsData: {},
    };
  },
  watch: {
    historicalData() {
      this.rsData = [...this.historicalData];
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.ivu-icon-ios-information-circle:before {
  display: none !important;
}

.goodRoadIconRed {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #ff5050;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.goodRoadIconBlue {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #4ebaf1;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.goodRoadIconGrey {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  // background: #454545;
  background: #6f4118;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.goodRoadIconYellow {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #ffff99;
  color: black;
  text-align: center;
  display: inline-block;
}

.goodRoadIconGreen {
  width: 16px;
  height: 16px;
  border-radius: 100px;
  line-height: 15px;
  font-size: 10px;
  font-weight: bold;
  background: #228b22;
  color: #ffffff;
  text-align: center;
  display: inline-block;
}

.ivu-tabs-nav-scroll {
  overflow: hidden;
  white-space: nowrap;
  border-bottom: 2px solid #4ebaf1;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  border: unset;
  color: #4ebaf1;
}

.ivu-tabs-nav-scroll .ivu-tabs-nav {
  padding: 0 4px;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card {
  position: unset;
  overflow: unset;
}

.thai-hilo-history-tabs .ivu-tabs-bar {
  border-bottom: unset;
  margin-bottom: unset;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border: unset;
  border-radius: unset;
  font-size: 10px;
  padding-bottom: unset;
  font-weight: bold;
  color: $title-font-color-blue;
  position: relative;
  background: transparent;
  height: 31px;
  line-height: 24px;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab:last-of-type {
  margin-right: 0;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-nav-container {
  color: #4ebaf1;
}

.ivu-tabs-tab-active {
  border: unset;
  color: $title-font-color-blue;
  background: #f3f3f3;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:after {
  content: "";
  position: absolute;
  bottom: 5px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 7px solid #4ebaf1;
}

.thai-hilo-history-tabs .ivu-tabs-tabpane {
  padding: 5px;
}

.thai-hilo-history-tabs.ivu-tabs .ivu-tabs-tabpane {
  background-color: $trend-bg;
  min-height: 180px;
}

.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  border: unset;
  color: $title-font-color-blue;
  background: #f3f3f3;
}
.thai-hilo-history-tabs.ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 7px solid #4ebaf1;
}

.ivu-badge-count {
  line-height: 12px !important;
  height: 14px !important;
  width: 12px !important;
  margin-left: 3px !important;
}
</style>